import { AsyncPipe, NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { Toast } from '../models/toast.model';
import { ToastService } from '../toast.service';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  imports: [NgbToastModule, AsyncPipe, NgClass],
  standalone: true,
})
export class ToastContainerComponent {
  private readonly toastService = inject(ToastService);

  toasts$: Observable<Toast[]> = this.toastService.toasts$;
  remove(id: string) {
    this.toastService.remove(id);
  }
}
